import { useSyncExternalStore } from "react";
import { useData } from "../../runtime/provider";

/**
 * Re-renders when the lease changes and when Firebase reports its user, so a
 * cold start that read the saved sign-in re-evaluates once Firebase restores.
 */
export const useOfflineAccess = () => {
  const { offlineAccess } = useData();
  const isValid = useSyncExternalStore(
    offlineAccess.subscribeToOfflineAccess,
    () => offlineAccess.getOfflineAccessState().isValid,
    () => false,
  );
  return { isValid };
};
